import React from "react";
import TicketsHeader from "../../../Components/Tickets/TicketsHeader";
import TicketList from "../../../Components/Tickets/TicketList";
import { Tabs } from "antd";

import ChirchiqKirim from "../firms/Chirchiq/ChirchiqKirim";
import AmmafosKirim from "../firms/Ammafos/AmmafosKirim";
import KaliyKirim from "../firms/Kaliy/KaliyKirim";

const onChange = (key) => {
  console.log(key);
};

const items = [
  {
    key: "1",
    label: "Max-Chirchiq",
    children: <ChirchiqKirim />,
  },
  {
    key: "2",
    label: "Olmaliq",
    children: <AmmafosKirim />,
  },
  {
    key: "3",
    label: "Kaliy",
    children: <KaliyKirim />,
  },
];
export default function Calculation() {
  return (
    <div>
      <TicketsHeader title={"Xisobot"} />

      <div className="max-w-[900px] w-[100%] pb-[70px] m-auto">
        <Tabs
          defaultActiveKey="1"
          className="text-[14px]"
          items={items}
          onChange={onChange}
        />
      </div>
    </div>
  );
}
